<script>

    let { children, color='', href='', onclick=undefined, disabled=false, autofocus=false, class: className='' } = $props();

    let buttonEl;

    export function focus() {
        buttonEl?.focus();
    }

</script>

{#if href}
    <a class='button {className}' href={href} autofocus={autofocus}>
        {@render children?.()}
    </a>
{:else}
    <button bind:this={buttonEl} class='button {color} {className}' {onclick} {disabled} {autofocus}>
        {@render children?.()}
    </button>
{/if}

<style>

    .button {
        --color: var(--text-color);
        --background: var(--box-color);
        --background-hover: var(--box-hover-color);
        --outline: var(--accent-background);

        appearance: none;
        background: var(--background);
        color: var(--color);
        border: none;
        border-radius: 8px;
        padding: 0.7em 1.4em;
        font-size: 1.2em;
        text-decoration: none;
        display: flex;
        align-items: center;
        gap: 0.8em;
        cursor: pointer;
        outline: none;
        transition: background-color 0.2s ease, opacity 0.2s ease;

        white-space: nowrap;
    }

    .button:hover {
        background-color: var(--background-hover);
    }

    .button:active {
        background-color: var(--background-hover);
    }

    .button:disabled {
        opacity: 0.5;
        cursor: not-allowed;
    }
    
    .button:disabled:hover {
        background-color: var(--background);
    }


    .button:focus-visible {
        outline: 2px solid var(--accent-background);
        outline-offset: 2px;
    }

    @supports (color: color-mix(in srgb, red 50%, blue)) {
        .button:focus-visible {
            outline: 4px solid var(--outline);
            outline-offset: 0;
        }
    }


    /* Accent button style */

    .button.accent {
        --color: var(--accent-color);
        --background: var(--accent-background);
        --background-hover: color-mix(in srgb, var(--accent-background) 85%, #000);
        --outline: color-mix(in srgb, var(--accent-background) 35%, transparent);
    }

</style>